var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.3809 40.7034L1.66602 20.861","stroke":"white","strokeWidth":"4","key":0}),React.createElement("line",{"x1":"2.02571","y1":"23.2439","x2":"21.9624","y2":"2.17212","stroke":"white","strokeWidth":"4","key":1})]);
}

ChevronLeft.defaultProps = {"width":"24","height":"43","viewBox":"0 0 24 43","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
